<template>
  <div class="container-tooltip">
    <!-- default slot -->
    <div
      ref="masterContent"
      class="content">
      <slot/>
    </div>

    <!-- message slot -->
    <div
      ref="messageContent"
      :style="messageStyle"
      class="message">
      <slot name="message">{{ message }}</slot>
    </div>
  </div>
</template>

<script>
const POSITION = Object.freeze({
  ENUM: {
    TOP: 'top',
    BOTTOM: 'bottom',
  },
  get values () {
    return Object.values(this.ENUM)
  },
})

export default {
  name: 'Tooltip',

  props: {
    message: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: POSITION.ENUM.TOP,
      validator: (position) => {
        return POSITION.values.includes(position)
      },
    },
  },

  data () {
    return {
      messageStyle: {},
      observer: null,
      observerConfig: {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      },
    }
  },

  mounted () {
    this.setUI()
    this.setupObserver()
  },

  beforeDestroy () {
    this.disconnectObserver()
  },

  methods: {
    setUI () {
      this.messageStyle = this.getMessageStyle()
    },
    setupObserver () {
      this.observer = new MutationObserver((mutations) => {
        this.setUI()
      })
      this.observer.observe(this.$refs.masterContent, this.observerConfig)
    },
    disconnectObserver () {
      this.observer.disconnect()
    },
    masterContentBound () {
      return this.$refs.masterContent.getBoundingClientRect()
    },
    messageContentBound () {
      return this.$refs.messageContent.getBoundingClientRect()
    },
    getMessageStyle () {
      const { position, masterContentBound, messageContentBound } = this
      const { TOP, BOTTOM } = POSITION.ENUM
      const mstCntBound = masterContentBound()
      const msgCntBound = messageContentBound()
      const padding = 8
      let styles = {}

      if (position === TOP || position === BOTTOM) {
        styles.left = `${mstCntBound.x + ((mstCntBound.width / 2) - (msgCntBound.width / 2))}px`
      }

      if (position === TOP) {
        styles.top = `${mstCntBound.y - msgCntBound.height - padding}px`
      } else if (position === BOTTOM) {
        styles.top = `${mstCntBound.y + mstCntBound.height + padding}px`
      }

      return styles
    },
  },
}
</script>

<style scoped>
  .container-tooltip {
    position: relative;
    cursor: default;
  }

  .content:hover ~ .message {
    visibility: visible;
  }

  .content {
    display: inline-flex;
  }

  .message {
    position: fixed;
    z-index: 1;
    width: 280px;
    padding: 8px;
    background-color: #fff;
    box-shadow: 0 4px 16px -4px rgba(9,45,66,.25), 0 0 0 1px rgba(9,45,66,.08);
    visibility: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/custom/Tooltip.vue